import { createFileRoute } from '@tanstack/react-router'
import LocationPage from '@/views/location-page'
import { Spinner } from '@/components/ui/spinner'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/',
)({
  component: RouteComponent,
  pendingComponent: Spinner,
  beforeLoad: () => ({ removeContentPadding: true }),
})

function RouteComponent() {
  return <LocationPage />
}
